import { combineReducers } from 'redux';

import compareState, { compareInitial } from './compare';
import creatorState, { creatorInitialState } from './creator';
import listState, { listInitialState } from './list';

export const datascienceInitialState = { 
  compareState: compareInitial,
  creatorState: creatorInitialState,
  listState: listInitialState,
}

export const datascienceState = combineReducers({ 
  compareState,
  creatorState,
  listState
})